module.exports = __webpack_public_path__ + "static/media/MergensanaAmar.08955cf6.png";